import { useTranslation } from 'react-i18next';

export default function AboutStats() {
  const { t } = useTranslation('about');

  const stats = [
    { value: '200+', label: t('statsArtists') },
    { value: '500+', label: t('statsEvents') },
    { value: '8+', label: t('statsYears') },
    { value: '15+', label: t('statsGenres') },
  ];

  return (
    <section className="py-12 md:py-16 bg-amber-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-5xl font-bold text-amber-700 mb-2">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}